import "../actus.css";
import { Link } from "react-router-dom";
import { ConvertDate } from "../../ConvertDate";

const ItemActuality = ({ actu }) => {
		return (
			<div className="itemActuality">
				<article className="postcard dark blue">
					<a
						className="postcard__img_link imgSize"
						href={`/actualites/detail/${actu.id}`}
						style={{
							backgroundImage: `url(${actu.image})`,
							backgroundRepeat: "no-repeat",
							backgroundPosition: "top",
							backgroundSize: "cover",
							display: "flex",
						}}
					></a>
					<div className="postcard__text">
						<h3 className="postcard__title titleViolet">
							{actu.titre}
						</h3>
						<div className="postcard__subtitle grey">
							{ConvertDate(actu.date)}
						</div>
						<div className="postcard__bar"></div>
						<div className="postcard__preview-txt ">
							{actu.mini_description}
						</div>
						<div className="postcard__preview-txt">
							{actu.text.substr(0, 250) + "..."}
						</div>

						<div className="postcard__tagbox">
							<Link
								to={`/actualites/detail/${actu.id}`}
								className="btn-custom rose"
							>
								EN SAVOIR PLUS
							</Link>
						</div>
					</div>
				</article>
			</div>
		);
	};

export default ItemActuality;